import PropTypes, { shape } from "prop-types"
import { Overflowing } from "components/ui"
import EventRow from "components/admin/events/event_row"

const EventsList = ({
  events,
  organization,
  noLogoUrl,
  ccwEnabled,
  ccwRegistrationsPublished,
  isActingStaff
}) => {
  return events.length > 0 ? (
    <Overflowing className="Overflowing">
      <table className="table" cellPadding="0" cellSpacing="0">
        <thead>
          <tr>
            <th className="p-0">
              <span className="screen-reader-text">Signup image</span>
            </th>
            <th>Name</th>
            <th>Date</th>
            <th>Attendees</th>
            <th>Visibility</th>
            <th>Registration</th>
            <th>Most Recent</th>
            {ccwRegistrationsPublished && ccwEnabled && (
              <th>
                <span className="screen-reader-text">Church Center link</span>
              </th>
            )}
          </tr>
        </thead>
        <tbody>
          {events.map(e => (
            <EventRow
              {...e}
              organization={organization}
              key={e.id}
              noLogoUrl={noLogoUrl}
              ccwEnabled={ccwEnabled}
              ccwRegistrationsPublished={ccwRegistrationsPublished}
              isActingStaff={isActingStaff}
            />
          ))}
        </tbody>
      </table>
    </Overflowing>
  ) : (
    <div className="ta-c p-4">
      <div className="blank-state__hero">
        <img
          src="/static/blank-states/registrations-no-event.svg"
          className="mb-4"
          alt="No results"
        />
      </div>
      <div className="blank-state__msg blank-state__msg--wide">
        There are no signups that match your search query.
      </div>
    </div>
  )
}

const { bool, number, string } = PropTypes

EventsList.propTypes = {
  events: shape({
    id: number
  }),
  organization: shape({}),
  noLogoUrl: string,
  ccwEnabled: bool,
  ccwRegistrationsPublished: bool,
  isActingStaff: bool
}

export default EventsList
